import { render, staticRenderFns } from "./HeroDetails.vue?vue&type=template&id=35857689&"
import script from "./HeroDetails.vue?vue&type=script&lang=js&"
export * from "./HeroDetails.vue?vue&type=script&lang=js&"
import style0 from "./HeroDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports